import React from 'react'
import './VoicesSeries.scss'
import {
  Col,
  Container,
  Row
} from 'reactstrap'
import books from '../../data/book-data'
import Book from '../Book/Book'

function StAugustineSeries() {
  return (
    <Container fluid className="VoicesSeries d-flex flex-column align-items-center pb-5">
      <h1 className="h1 text-center mb-4 mt-md-4">Voices Series</h1>
      <Container fluid>
        <Row className="my-2">
          <Col>
            <div className="w-75 mx-auto">
              <p>Jane is also the author of the Voices Series available as a paperback or ebook from Amazon.</p>
              <p>The Voices Series follows the lives of people who hear voices, people with schizophrenia, in some of
                the most fascinating periods in history.</p>
              <p>From the 12th Century crusades to the Holy Lands to 17th Century England and the rise of witchcraft,
                the roots of mental health treatment, laws, and beliefs set the stage for the 19th Century American age
                of reformers. The Voices Series brings the real life personalities of those who changed history to
                life.</p>
            </div>
          </Col>
        </Row>

        <Row xs="1" sm="3" className="flex-wrap align-items-md-end">
          {books.slice(0, -1).map(book => (
            <Col key={book.title}>
              <Book {...book} />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  )

}

export default StAugustineSeries
